const API_BASE_URL = "/api";

const getStaffToken = () => {
  return localStorage.getItem("staffToken");
};

const getAuthHeaders = () => {
  const token = getStaffToken();

  return {
    "Content-Type": "application/json",
    Authorization: token ? `Bearer ${token}` : "",
  };
};

export const adminLogin = async ({ email, password }) => {
  const response = await fetch(`${API_BASE_URL}/staff/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "خطا در ورود به پنل مدیریت");
  }

  return data;
};

export const getAdminProfile = async () => {
  const response = await fetch(`${API_BASE_URL}/staff/me`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${getStaffToken()}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "خطا در دریافت اطلاعات ادمین");
  }

  return data;
};

export const changeAdminPassword = async ({
  currentPassword,
  newPassword,
  confirmPassword,
}) => {
  const response = await fetch(`${API_BASE_URL}/staff/change-password`, {
    method: "PUT",
    headers: getAuthHeaders(),
    body: JSON.stringify({
      currentPassword,
      newPassword,
      confirmPassword,
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "خطا در تغییر رمز عبور");
  }

  return data;
};

export const getAdminContents = async ({
  type = "",
  status = "",
  limit = "",
  page = "",
} = {}) => {
  const params = new URLSearchParams();

  if (type) params.append("type", type);
  if (status) params.append("status", status);
  if (limit) params.append("limit", limit);
  if (page) params.append("page", page);

  const queryString = params.toString();

  const response = await fetch(
    `${API_BASE_URL}/content/admin/all${queryString ? `?${queryString}` : ""}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getStaffToken()}`,
      },
    }
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "خطا در دریافت لیست محتواها");
  }

  return data;
};

export const getAdminContentById = async (id) => {
  const response = await fetch(`${API_BASE_URL}/content/admin/${id}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${getStaffToken()}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "خطا در دریافت جزئیات محتوا");
  }

  return data;
};

export const createAdminContent = async (contentData) => {
  const response = await fetch(`${API_BASE_URL}/content/admin/create`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(contentData),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "خطا در ایجاد محتوا");
  }

  return data;
};

export const updateAdminContent = async (id, contentData) => {
  const response = await fetch(`${API_BASE_URL}/content/admin/update/${id}`, {
    method: "PUT",
    headers: getAuthHeaders(),
    body: JSON.stringify(contentData),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "خطا در ویرایش محتوا");
  }

  return data;
};

export const deleteAdminContent = async (id) => {
  const response = await fetch(`${API_BASE_URL}/content/admin/delete/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${getStaffToken()}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "خطا در حذف محتوا");
  }

  return data;
};
export const uploadAdminImage = async (file) => {
  const token = localStorage.getItem("staffToken");

  const formData = new FormData();
  formData.append("image", file);

  const response = await fetch(`${API_BASE_URL}/content/admin/upload-image`, {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
    body: formData,
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "خطا در آپلود تصویر");
  }

  return data;
};

export const getAnalyticsSummary = async () => {
  const response = await fetch(`${API_BASE_URL}/analytics/summary`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${getStaffToken()}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "خطا در دریافت آمار بازدید");
  }

  return data.summary || {};
};
